import { createSelector } from 'reselect'

const getPaints = (state, layerName) => {
  return state.layer.paints
}

const getLayerName = (state, layerName) => {
  return layerName
}

export const makeGetPaint = () => {
  return createSelector([getPaints, getLayerName], (paints, layerName) => {
    if (paints && layerName) {
      return paints[layerName]
    } else {
      return {}
    }
  })
}



// WEBPACK FOOTER //
// ./src/selectors/paintSelector.js